<template>
    <div class="products-row mt-6">
        <template v-if="products && products.length == 0 ">
            <loaderApp v-if="!notFound" />
            <p class="pb-3" v-if="notFound" >Items Not Found</p>
        </template>
        <template v-else>
            <itemProduct v-for="(product, i) in products" 
                :key="product.ID + i * 100" 
                :product="product" 
                :category="category" 
                :dayProducts="products" 
                @open-popup="emitOpenPopup"
                :editOrder="false"
            ></itemProduct>
        </template>
    </div>
</template>

<script>

import itemProduct from '@/components/itemProduct.vue';
import loaderApp from '@/components/common/loaderApp.vue';

export default {
    name: 'cardWizard',
    props: ['products', 'category', 'weeklyPlan'],
      components: {
        itemProduct,
        loaderApp
    },
    data: () => ({
        editOrder: false,
        notFound: false,
    }),
    methods: {
        emitOpenPopup() {
            this.$emit('open-popup-to-parent');
        }           
    },
    emits: ['open-popup-to-parent'],
    computed: {      
        menus() {
            return this.$store.getters.getMenus;
        },        
    },
    async beforeMount() {
           
        setTimeout(() => {
            this.notFound = true;
        }, 4000);
    
    },
    watch: {

    }
}
</script>